import Message from "base/Message";
import ConfirmModal from "modal/ConfirmModal";

export default class AjaxConfirmModal extends ConfirmModal {
    constructor(message, title = undefined, callback, settings = {}) {
        super(message, title, $.extend({}, settings, {showLoading: true}));

        this.on("confirm", async () => {
            if (this.isLoading()) {
                return;
            }
            this.showLoading();

            try {
                let result = await callback();

                this.emit("success", result);
            } catch (e) {
                new Message(e.message, "An error occurred");
                this.stopLoading();
            }
        }).on("cancel", () => {
            if (this.isLoading()) {
                return false;
            }

            this.destroy();
        });
    }
}
